import { formatToCurrency } from "utils/currency";
import {
  BankStatementIncomeSource,
  DocType,
  PayStubIncomeSource,
  W2IncomeSources
} from "../../types";
import { BankStatementDetails } from "./slices/BankStatementDetails";
import { PayStubDetails } from "./slices/PayStubDetails";
import { W2DocDetails } from "./slices/W2DocDetails";
import { PayrollIncomeDetails } from "./slices/PayrollIncomeDetails";
import { BankIncomeSource, PayrollEmployment } from "types/landlord/reports";
import { PayrollData } from "./types";
import { BankAccountDetails } from "./slices/BankAccountDetails";
import { PayStubI } from "views/applications-id-report/utils/PayStub";

interface VerifiedIncomeSourcesTableExpanderProps {
  rowData:
    | PayStubIncomeSource
    | BankStatementIncomeSource
    | W2IncomeSources
    | BankIncomeSource
    | PayrollData;
  employment?: PayrollEmployment[];
}

const hasDocType = (
  data: any
): data is
  | PayStubIncomeSource
  | BankStatementIncomeSource
  | W2IncomeSources => {
  return "docType" in data;
};

export const VerifiedIncomeSourcesTableExpander = ({
  rowData,
  employment
}: VerifiedIncomeSourcesTableExpanderProps) => {
  return (
    <div className="py-8 px-6">
      <div className="flex gap-16 pb-6">
        <div className="flex flex-col gap-2">
          <p className="text-content-700 font-medium text-xs">
            Gross monthly income
          </p>
          <p className="text-2xl font-bold text-content-1000">
            {formatToCurrency(rowData.gross_monthly_income)}
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-content-700 font-medium text-xs">
            Net monthly income
          </p>
          <p className="text-2xl font-bold text-content-1000">
            {formatToCurrency(rowData.net_monthly_income)}
          </p>
        </div>
      </div>
      {hasDocType(rowData) && rowData.docType === DocType.PAY_STUB ? (
        <PayStubDetails payStubs={rowData.pay_stubs as PayStubI[]} />
      ) : null}
      {hasDocType(rowData) && rowData.docType === DocType.BANK_STATEMENT ? (
        <BankStatementDetails
          bankStatementData={rowData as BankStatementIncomeSource}
        />
      ) : null}
      {hasDocType(rowData) && rowData.docType === DocType.W2 ? (
        <W2DocDetails forms={rowData.forms} />
      ) : null}
      {rowData.income_source_type === "payroll" ? (
        <PayrollIncomeDetails
          payroll={rowData as PayrollData}
          employment={employment as PayrollEmployment[]}
        />
      ) : null}
      {rowData.income_source_type === "bank" ? (
        <BankAccountDetails source={rowData as BankIncomeSource} />
      ) : null}
    </div>
  );
};
